import { Sheet, SheetContent, SheetHeader, SheetTitle } from './ui/sheet'
import { Button } from './ui/button'
import { Badge } from './ui/badge'
import { Separator } from './ui/separator'
import { Minus, Plus, Trash2, ShoppingCart as ShoppingCartIcon } from 'lucide-react'
import { ImageWithFallback } from './figma/ImageWithFallback'
import { ProductCard } from './ProductCard'
import { CatalogItem, CatalogItemListReq, PropertyFilter } from '../types/catalog'; 
import { CartProdInfo } from './CartProdInfo'
import { catalogClient } from '../services/grpc';
import { CartReq,CartAddReq,CartRemoveReq,CartRes } from '../generated/catalog_pb'; 
import Cookies from 'js-cookie'
import { Input } from './ui/input'
export interface CartItem {
  product: CatalogItem
  quantity: number
  storage:string
  price:number

}
 
interface ShoppingCartProps {
  isOpen: boolean
  onOpenChange: (open: boolean) => void
  cartItems: CartItem[]
  onUpdateQuantity: (productId: number, quantity: number,storage:string) => void
  onRemoveItem: (productId: number,storage:string) => void
  onOrder:()=>void
  customerName: string
  customerPhone:string
  setCustomerName:(customerName:string)=>void
  setCustomerPhone:(customerPhone:string)=>void
  setCartItemCount:(totalItems:number)=>void
  setIsInCartStorage:(items:string[])=>void
}

export function ShoppingCart({ 
  isOpen, 
  onOpenChange, 
  cartItems = [], // Default to empty array
  onUpdateQuantity, 
  onRemoveItem,
  onOrder,
  customerName,
  customerPhone,
  setCustomerName,
  setCustomerPhone,
  setCartItemCount,
  setIsInCartStorage
}: ShoppingCartProps) {
  let req=false;
  if (cartItems.length==0) {
    const guid = Cookies.get('guid');
    if (typeof guid === 'string'&&req==false) {
      req=true;
      const cartReq = new CartReq();
      cartReq.setGuid(guid);
      catalogClient.getCart(cartReq, {}, (err, response) => {
        if (cartItems.length==0) {
        if (err) {
          console.error('Error fetching cart:', err.code, err.message);
        } else {
           var inCar:string[]=[];
           const items = response.getItemsList();
           items.forEach((item) => {
            cartItems.push({
              product: {
                id: item.getProductId(),
                name: item.getName(),
                price: item.getPrice(),
                pic: item.getPic(),
                qty: item.getQty(),
                code: item.getSize(),
                desc: '',
                title: item.getSize()
              },
              quantity: item.getQty(),
              storage:item.getStorage(),
              price: item.getPrice(),
            });    
          });
        }}
      });
    }
  }
  const safeCartItems = cartItems || []
  const totalItems = safeCartItems.reduce((sum, item) => sum + item.quantity, 0)
  const totalPrice = safeCartItems.reduce((sum, item) => sum + (item.price * item.quantity), 0)
  setCartItemCount(totalItems)
  return (
    <Sheet open={isOpen} onOpenChange={onOpenChange}>
      <SheetContent className="w-full sm:max-w-lg">
        <SheetHeader>
          <SheetTitle className="flex items-center gap-2">
            <ShoppingCartIcon className="h-5 w-5" />
            Ваша корзина ({totalItems})
          </SheetTitle>
        </SheetHeader>
        
        <div className="space-y-4 max-h-[100vh] overflow-y-auto pr-2">
          {safeCartItems.length === 0 ? (
            <div className="text-center py-8">
              <ShoppingCartIcon className="h-12 w-12 mx-auto text-gray-400 mb-4" />
              <p className="text-gray-500">В корзине ничего нет.</p>
            </div>
          ) : (
            <>
              <div className="space-y-4   overflow-y-auto">
                {safeCartItems.map((item) => (
                  <div key={`${item.product.id}_${item.storage}`} className="flex items-center space-x-4 p-4 border rounded-lg">
                    <ImageWithFallback
                      src= {`https://cdn.yutongoriginal.ru/product_images/${item.product.code}.jpg`}
                      alt={item.product.name}
                      className="w-16 h-16 object-cover rounded"
                    />
                    <CartProdInfo product={item.product} storage={item.storage} price={item.price}/>                                
                    <div className="flex flex-col items-end space-y-2">
                      <div className="flex items-center space-x-1">
                        <Button
                          size="lg"
                          variant="outline"
                          onClick={() => onUpdateQuantity(item.product.id, Math.max(0, item.quantity - 1),item.storage)}
                          className="h-9 w-9 p-0"
                        >
                          <Minus className="h-6 w-6" />
                        </Button>
                        <Badge variant="outline" className="min-w-8 text-center text-xl">
                          {item.quantity}
                        </Badge>
                        <Button
                          size="lg"
                          variant="outline"
                          onClick={() => onUpdateQuantity(item.product.id, item.quantity + 1,item.storage)}
                          className="h-9 w-9 p-0"
                        >
                          <Plus className="h-6 w-6" />
                        </Button>
                      </div>
                      
                      <Button
                        size="lg"
                        variant="ghost"
                        onClick={() => onRemoveItem(item.product.id,item.storage)}
                        className="h-12 w-12 p-0 text-red-500 hover:text-red-700"
                      >
                        <Trash2 className="h-10 w-10" />
                      </Button>
                    </div>
                  </div>
                ))}
              </div>
              
              <Separator />
              
              <div className="space-y-4">
                <div className="flex justify-between items-center inline-flex items-center justify-center pl-4">
                  <span className="font-semibold items-center inline-flex items-center justify-center">Итого: {totalPrice.toFixed(2)}₽</span>
                </div>
                <div className="space-y-2 p-3">
                <div>
    <label htmlFor="fio" className="block text-lg font-medium mb-1">Ваше имя:</label>
    <Input 
      id="fio"
      name="fio"
      value={customerName}
      placeholder="Петров Сидор Васильевич"
      className="w-full   placeholder:text-black/70 min-h-12" 
      onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCustomerName(e.target.value)}
    />
  </div>

  <div>
    <label htmlFor="phone" className="block text-lg font-medium mb-1">Номер вашего телефона</label>
    <Input 
      id="phone"
      name="phone"
      value={customerPhone}
      type="tel"
      placeholder="+7 (999) 111-22-33"
      className="w-full   placeholder:text-black/70 min-h-12" 
      onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCustomerPhone(e.target.value)}
    />
  </div>
                </div>
                <div className="space-y-2">
                  <Button className="w-full bg-gradient-to-br from-blue-950 to-blue-800 hover:bg-[#d97009] text-white min-h-12" size="lg" onClick={() =>onOrder()}>
                    Оформить заказ
                  </Button>
                  <Button variant="outline" className="w-full" onClick={() =>  onOpenChange(false)}>
                    Продолжить покупки 
                  </Button>
                </div>
              </div>
            </>
          )}
        </div>
      </SheetContent>
    </Sheet>
  )
}